export const PASSWORD =
  /(?=^.{8,24}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_\-+}{&;:;'?/&.,<>])(?!.*\s).*$/g; // One lowercase, one uppercase, one digit, one special char, length 8 - 24
export const PHONE = /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$/i;
export const MAIL = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/g;
